export function formatNum(num: number): string { return `${num >= 10 ? '' : '0'}${num}`; }

export const MINUTE = 60;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;

export type TimeFormat = 'HH:mm' | 'mm:ss';

export function getTimestamp(dateTimeString?: string): number {
    if (!dateTimeString)
        return Math.floor(new Date().getTime() / 1000); // current timestamp
    else
        return Math.floor(new Date(dateTimeString).getTime() / 1000);
}

export function secondsAgo(time: number): number {
    return getTimestamp() - time;
}

export function stringToTimeSeconds(str: string, mode: TimeFormat): number {
    if (mode === 'HH:mm') {
        const [hours, minutes] = str.split(':'); // disregard seconds if present
        return Number.parseInt(hours) * HOUR + Number.parseInt(minutes) * MINUTE;
    }
    else {
        const [minutes, seconds] = str.split(':');
        return Number.parseInt(minutes) * MINUTE + Number.parseInt(seconds);
    }
}

export function secondsToTimeString(seconds: number, mode: TimeFormat): string {
    if (mode === 'HH:mm') {
        const hours = Math.floor(seconds / HOUR);
        return `${formatNum(hours)}:${formatNum(Math.floor((seconds - hours * HOUR) / MINUTE))}`;
    }
    else {
        return `${formatNum(Math.floor(seconds / MINUTE))}:${formatNum(Math.floor(seconds % MINUTE))}`;
    }
}

export function breakDownSeconds(seconds: number): { days: number; hours: number; minutes: number; seconds: number } {
    const result = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    let remainingSeconds = seconds;

    if (remainingSeconds >= DAY) {
        result.days = Math.floor(remainingSeconds / DAY);
        remainingSeconds -= result.days * DAY;
    }

    if (remainingSeconds >= HOUR) {
        result.hours = Math.floor(remainingSeconds / HOUR);
        remainingSeconds -= result.hours * HOUR;
    }

    if (remainingSeconds >= MINUTE) {
        result.minutes = Math.floor(remainingSeconds / MINUTE);
        remainingSeconds -= result.minutes * MINUTE;
    }

    result.seconds = Math.floor(remainingSeconds);
    return result;
}